module.exports = {
      id: "personalise-usage",
      viewBox: "0 0 14.128 12.555",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#personalise",
      toString: function () {
        return this.url;
      }
    }